import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { ValidatorForm } from 'react-material-ui-form-validator';
import { Input, Button, H2 } from 'components/Ui/index';

import styles from './styles.scss';
import commonStyles from '../styles.scss';

const EditBillingContactForm = ({ onClose, billingAccount }) => {
  const contact = billingAccount.contacts[0];

  const [values, changeValues] = useState(contact);

  const handleChange = ({ target: { value, name } }) => {
    changeValues({ ...values, [name]: value });
  };

  const handleSubmit = () => {};

  return (
    <ValidatorForm onSubmit={handleSubmit}>
      <H2 className={commonStyles.header}>Edit name</H2>
      <div className={styles.inputFields}>
        <Input
          label="First Name:"
          name="firstName"
          id="firstName"
          ariaLabel="First Name"
          smallLabel
          value={values.firstName}
          onChange={handleChange}
        />
        <Input
          label="Last Name:"
          name="lastName"
          id="lastName"
          ariaLabel="Last Name"
          smallLabel
          value={values.lastName}
          onChange={handleChange}
        />
      </div>
      <Fragment>
        <div className={styles.formBottom}>
          <Button
            className={commonStyles.cancelButton}
            text="Cancel"
            type="button"
            onClick={onClose}
          />
          <Button
            className={commonStyles.button}
            text="Save"
            type="button"
            onClick={handleSubmit}
          />
        </div>
      </Fragment>
    </ValidatorForm>
  );
};

EditBillingContactForm.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default EditBillingContactForm;
